import React, { useState, useEffect } from "react";
import { Autocomplete, TextField } from "@mui/material";
import { getAllStaff } from "../../apis/staff";

interface SelectInputProps {
  label: string;
  className?: string;
  id?: string;
  setValue?: any;
  defaultValue?: StaffInformation;
}

const SelectStaff: React.FC<SelectInputProps> = ({
  id,
  label,
  setValue,
  defaultValue,
  className,
}) => {
  const [selectedValue, setSelectedValue] = useState<
    StaffInformation | undefined
  >(defaultValue || undefined);

  useEffect(() => {
    setSelectedValue(defaultValue);
    getStaffs();
  }, [defaultValue]);

  const [searchStaffs, setSearchStaffs] = useState<StaffInformation[]>([]);
  const getStaffs = async () => {
    const [response, error] = await getAllStaff();
    if (response) {
      setSearchStaffs(response);
    } else {
      console.log(error);
    }
  };
  const handleAutoCompleteChange = (
    event: React.ChangeEvent<{}>,
    newValue: StaffInformation | null
  ) => {
    console.log(newValue);
    if (newValue) {
      setSelectedValue(newValue);

      if (newValue && id) {
        // id = option.publicId;
        setValue(id, newValue.publicId);
      }
    } else {
      setSelectedValue(undefined);
    }
  };

  return (
    <Autocomplete
      id="staff-autocomplete"
      className={className}
      options={searchStaffs}
      getOptionLabel={(option) =>
        `${option.title} ${option.firstName} ${option.lastName}`
      }
      value={selectedValue}
      onChange={handleAutoCompleteChange}
      renderInput={(params) => (
        <TextField {...params} label={label} variant="outlined" fullWidth />
      )}
    />
  );
};

export default SelectStaff;
